import { PublicPolicyPage } from '@/components/PublicPolicyPage';

export default function PrivacyPage() {
  return (
    <PublicPolicyPage
      title="Privacy Policy"
      summary="This Privacy Policy explains how RJ Venture Tech LLC, operating as ADA Widget, collects, uses, shares, retains, and protects personal information when you visit the website, create an account, or use the service."
      testId="heading-privacy"
    >
      <section>
        <h2 className="mb-3 text-xl font-bold text-white">1. Scope</h2>
        <p>This policy covers the ADA Widget website, dashboard, accessibility widget, automated scanning, reports, and related customer communications provided by RJ Venture Tech LLC. It does not govern a customer’s own privacy practices or website content.</p>
      </section>

      <section>
        <h2 className="mb-3 text-xl font-bold text-white">2. Information collected</h2>
        <ul className="list-disc space-y-2 pl-6">
          <li><strong className="text-white">Account information:</strong> name, email address, authentication details, and account preferences supplied through the sign-in provider.</li>
          <li><strong className="text-white">Website information:</strong> site names, domains, widget settings, installation status, accessibility statements, and scan history.</li>
          <li><strong className="text-white">Scan information:</strong> public page content needed to perform a scan, detected issues, limited HTML examples, scores, and remediation reports.</li>
          <li><strong className="text-white">Usage and technical information:</strong> widget visits, feature activity, browser or device information, IP-derived logs, timestamps, and diagnostic data needed to operate and secure the service.</li>
          <li><strong className="text-white">Communications:</strong> information you choose to provide in support, privacy, legal, or business communications.</li>
          <li><strong className="text-white">Payment information:</strong> if paid checkout is introduced, payment details should be collected by the selected payment processor rather than stored directly by ADA Widget, except for transaction and subscription records needed to administer the account.</li>
        </ul>
      </section>

      <section>
        <h2 className="mb-3 text-xl font-bold text-white">3. How information is used</h2>
        <p>Information may be used to create and secure accounts, provide widgets and scans, generate reports and statements, verify installations, show dashboard activity, measure service usage, troubleshoot issues, prevent abuse, communicate about the service, administer subscriptions, and meet legal obligations.</p>
      </section>

      <section>
        <h2 className="mb-3 text-xl font-bold text-white">4. Cookies and authentication</h2>
        <p>ADA Widget uses cookies and similar browser storage for essential functions such as authentication, session security, preferences, and service operation. Optional analytics or marketing technologies will be disclosed and presented with any consent or opt-out controls required by law before they are enabled.</p>
      </section>

      <section>
        <h2 className="mb-3 text-xl font-bold text-white">5. Sharing and service providers</h2>
        <p>Information may be shared with providers that support authentication, hosting, infrastructure, monitoring, communications, and future payment processing, but only as needed for those services. Information may also be disclosed to comply with law, protect rights and safety, investigate misuse, or support a merger, financing, or sale with appropriate safeguards.</p>
      </section>

      <section>
        <h2 className="mb-3 text-xl font-bold text-white">6. Sale of personal information</h2>
        <p>ADA Widget does not sell personal information for money. If data practices later constitute a “sale” or “sharing” under applicable privacy law, ADA Widget will provide the notices and choices required by that law.</p>
      </section>

      <section>
        <h2 className="mb-3 text-xl font-bold text-white">7. Retention</h2>
        <p>Information is kept for as long as reasonably needed to provide the service, maintain security and business records, resolve disputes, enforce agreements, and satisfy legal or accounting obligations. Retention varies by data type, purpose, and applicable law.</p>
      </section>

      <section>
        <h2 className="mb-3 text-xl font-bold text-white">8. Security</h2>
        <p>ADA Widget uses reasonable administrative, technical, and organizational measures designed to protect information. No online storage or transmission method is completely secure, so absolute security cannot be guaranteed.</p>
      </section>

      <section>
        <h2 className="mb-3 text-xl font-bold text-white">9. Privacy choices and rights</h2>
        <p>
          Depending on where you live, you may have rights to request access, correction, deletion, restriction, portability, or information about disclosures. Identity verification and legal exceptions may apply. Submit a request to{' '}
          <a className="font-bold text-[#8FA8FF] underline hover:text-white" href="mailto:support@adawidget.ai">
            support@adawidget.ai
          </a>
          .
        </p>
      </section>

      <section>
        <h2 className="mb-3 text-xl font-bold text-white">10. Children’s privacy</h2>
        <p>ADA Widget is intended for businesses and is not directed to children under 13 or the minimum age required by local law. The service should not knowingly collect personal information from children.</p>
      </section>

      <section>
        <h2 className="mb-3 text-xl font-bold text-white">11. International users</h2>
        <p>ADA Widget operates from the United States. If you access the service from another country, information may be transferred to and processed in the United States or other locations where service providers operate, subject to applicable legal safeguards.</p>
      </section>

      <section>
        <h2 className="mb-3 text-xl font-bold text-white">12. Changes and contact</h2>
        <p>
          ADA Widget may update this policy by posting a revised version and effective date and providing additional notice when required. Questions and privacy requests may be sent to{' '}
          <a className="font-bold text-[#8FA8FF] underline hover:text-white" href="mailto:support@adawidget.ai">
            support@adawidget.ai
          </a>{' '}
          or mailed to RJ Venture Tech LLC, 525 Rivera Dr, Fort Lauderdale.
        </p>
      </section>
    </PublicPolicyPage>
  );
}